// UserContext.js
import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  // Retrieve token from localStorage
  const storedToken = localStorage.getItem('token');

  // Initialize state based on the presence of a token in localStorage
  const [isLoggedIn, setIsLoggedIn] = useState(!!storedToken);
  const [token, setToken] = useState(storedToken);
  const [user, setUser] = useState(null);

  // Function to log in the user
  const login = (username, password, setError, navigate) => {
    const axiosUrl = 'https://api.skilledcrm.com/login/';

    //declares user data (password and username)
    const data = {
      username: username,
      password: password,
    };

    //uses the axios.post function to send the data to backend
    axios
      .post(axiosUrl, data)
      .then((response) => {
        //creates a response in console to ensure that the data sent was correct
        console.log('Response: ', response.data);
        //sets token data
        localStorage.setItem('token', response.data['token']);
        //sets user data
        localStorage.setItem('admin', response.data['is_admin']);
        localStorage.setItem('user', response.data['id']);

        setIsLoggedIn(true);
        setToken(response.data['token']);
        setUser(response.data['id']);

        if(response.data['is_admin']){
          navigate('/admin-dashboard');
        }else{
          navigate('/');
        }


      })
      .catch((error) => {
        console.error('Error: ', error.response.status);
        if (error.response.status === 400 || error.response.status === 401) {
          setError('Invalid username or password.');
        } else {
          setError("Sorry, we couldn't log you in due to an internal server error.");
        }
      });
  };

  // Function to log out the user

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('admin');
    setIsLoggedIn(false);
    setToken(null);
    window.location.reload();
  };

  // Listen for changes to localStorage
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'token') {
        const newToken = event.newValue;
        if (newToken) {
          // Token was added or changed
          setIsLoggedIn(true);
          setToken(newToken);
        } else {
          // Token was removed
          setIsLoggedIn(false);
          setToken(null);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <UserContext.Provider value={{ setToken, setIsLoggedIn, isLoggedIn, token, login, logout, user }}>
      {children}
    </UserContext.Provider>
  );
};
